import { IHisInfoItemBehavior } from "./IHisInfoItemBehavior";
import { HisInformationItem } from "../..";
import { StringUtility } from "../../../system/StringUtility";
import { IHisInformationValue, HisInformationTextValue } from "../../HisInformationValue";
import { PtNameBehavior } from "./PtNameBehavior";

/** HIS項目患者氏名・名を生成する */
export class PtNameMeiBehavior implements IHisInfoItemBehavior {
  private static readonly Key = "PT_NAME_MEI";
  
  getValue(hisInfoItems: HisInformationItem[]): IHisInformationValue {
    const itemValues =  hisInfoItems.filter(x => x.name === PtNameMeiBehavior.Key).map(x => x.value);
    const behavior = new PtNameBehavior();
    const values = behavior.getValue(hisInfoItems).data as string[];
    const mei = values.map(x => StringUtility.getTextAfterSpace(x));
    const data = itemValues.length > 0 ? itemValues : mei;
    return new HisInformationTextValue(PtNameMeiBehavior.Key, data);
  }
}
